import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'menu-4', 'Menu4', [["path",{"d":"M7 6h10"}],["path",{"d":"M4 12h16"}],["path",{"d":"M7 12h13"}],["path",{"d":"M7 18h10"}]]);